import { render, staticRenderFns } from "./CommonAnswer.vue?vue&type=template&id=52c3af0f&scoped=true"
import script from "./CommonAnswer.vue?vue&type=script&lang=js"
export * from "./CommonAnswer.vue?vue&type=script&lang=js"
import style0 from "./CommonAnswer.vue?vue&type=style&index=0&id=52c3af0f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c3af0f",
  null
  
)

export default component.exports